export default "__VITE_ASSET__CwsMNVKJ__"